// src/services/storageActions.ts

import { message, Modal } from "antd";
import { unifiedStorage } from "../../../../../helpers";
import { StorageItem } from "../types/storage.types";

export class StorageActions {


  static async forceSync(swController?: ServiceWorker): Promise<void> {
    if (!swController) {
      message.error("Service Worker no disponible");
      return;
    }

    try {
      message.loading("Forzando sincronización...", 0);
      swController.postMessage({ type: "SYNC_NOW" });
      message.destroy();
      message.info("Sincronización iniciada");
    } catch (error) {
      message.destroy();
      message.error("Error iniciando sincronización");
      console.error("Error forzando sincronización:", error);
    }
  }

  static async deleteSelectedItems(
    selectedKeys: React.Key[],
    items: StorageItem[],
    onSuccess?: () => void
  ): Promise<void> {
    if (selectedKeys.length === 0) return;

    Modal.confirm({
      title: "Confirmar eliminación",
      content: `¿Estás seguro de eliminar ${selectedKeys.length} elemento(s)? Esta acción no se puede deshacer.`,
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          // Liberar URLs
          items
            .filter((item) => selectedKeys.includes(item.key) && item.url)
            .forEach((item) => {
              if (item.url) URL.revokeObjectURL(item.url);
            });

          // Eliminar elementos
          const deletePromises = selectedKeys.map(async (key) => {
            const item = items.find((i) => i.key === key.toString());
            if (!item) return;

            switch (item.category) {
              case "photo":
                await unifiedStorage.deletePhoto(item.key);
                break;
              case "workflow":
                await unifiedStorage.saveWorkflowData(item.key, null);
                break;
              case "sync":
                await unifiedStorage.removeSyncItem(item.key);
                break;
            }
          });

          await Promise.all(deletePromises);

          message.success(`${selectedKeys.length} elemento(s) eliminado(s)`);
          onSuccess?.();
        } catch (error) {
          console.error("Error eliminando elementos:", error);
          message.error("Error al eliminar algunos elementos");
        }
      },
    });
  }

  static async loadThumbnail(
    key: string,
    onUpdate: (key: string, url: string) => void,
    setLoading: (key: string, loading: boolean) => void
  ): Promise<void> {
    setLoading(key, true);

    try {
      const blob = await unifiedStorage.getPhoto(key);
      if (blob && blob.type.startsWith("image/")) {
        const url = URL.createObjectURL(blob);
        onUpdate(key, url);
      }
    } catch (error) {
      console.error(`Error cargando thumbnail para ${key}:`, error);
    } finally {
      setLoading(key, false);
    }
  }

  // Función auxiliar para limpiar URLs de objetos al desmontar componente
  static cleanupObjectURLs(items: StorageItem[]): void {
    items.forEach((item) => {
      if (item.url) {
        URL.revokeObjectURL(item.url);
      }
    });
  }
}
